'use client';

import React from 'react';

import { useSearchParams } from 'next/navigation';

import { BrowseProductsList } from '../../../components/BrowseProductsList';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { ImpressionsBatcherProvider } from '@/modules/impressions/ImpressionsBatcherProvider';
import { Components } from '@/modules/impressions/types';
import { useSearchId } from '@/modules/search/useSearchId';
import { useSearchTracking } from '@/modules/search/useSearchTracking';

export function SearchProductsList() {
  const searchId = useSearchId();
  const params = useSearchParams();
  const { handleProductClick } = useSearchTracking({ searchId });

  return (
    <>
      <ImpressionsBatcherProvider
        eventType={ActivityTrackerEventType.PRODUCT_IMPRESSIONS}
        impressionsType="productImpressions"
        batchLocationId="searchPage"
        batchLimit={8}
        depopSearchId={searchId}
        component={Components.InCountrySearch}
      >
        <BrowseProductsList
          handleProductClick={handleProductClick}
          query={params.get('q') || ''}
        />
      </ImpressionsBatcherProvider>
    </>
  );
}
